<template>
  <div>
    <svg xmlns="http://www.w3.org/2000/svg" width="100.691" height="100.691" viewBox="0 0 100.691 100.691"><defs></defs><path class="a" d="M58.346,8a50.346,50.346,0,1,0,50.346,50.346A50.337,50.337,0,0,0,58.346,8ZM89.875,47.649,52.521,85a3.248,3.248,0,0,1-4.592,0L26.817,63.89a3.248,3.248,0,0,1,0-4.592L31.409,54.7A3.248,3.248,0,0,1,36,54.7L50.225,68.926,80.689,38.463a3.248,3.248,0,0,1,4.594,0l4.592,4.594A3.248,3.248,0,0,1,89.875,47.649Z" transform="translate(-8 -8)"/><path class="b" d="M122.663,200.863a3.248,3.248,0,0,1-4.592,0L96.958,179.751a3.248,3.248,0,0,1,0-4.592l4.592-4.594a3.248,3.248,0,0,1,4.594,0l14.223,14.223,30.463-30.463a3.248,3.248,0,0,1,4.594,0l4.592,4.594a3.248,3.248,0,0,1,0,4.592Z" transform="translate(-78.141 -123.861)"/></svg>

    <h4 class="title">
      Success!
    </h4>

    <p class="description">
      Thank you for applying! Our team will review your application in the coming days, after which it will be published to the SupplyATeacher.org website.
    </p>

    <a href="/home" class="btn btn-teacher-form">
      Back to Home
    </a>
  </div>
</template>

<script>
export default {
  name: 'TeachersFormSuccess'
}
</script>

<style lang="scss" scoped>
.a,.b{fill:#60b661;}.a{opacity:0.4;}

.title {
  font-family: 'Roboto Slab';
  font-weight: 500;
  font-size: 22px;
  line-height: 29px;
  color: #60B661;
  margin-top: 20px;
  margin-bottom: 45px;
}
.description {
  font-family: 'Rubik';
  font-weight: 300;
  font-size: 16px;
  line-height: 19px;
  color: #6D6E71;
  margin-bottom: 45px;
}

.btn-teacher-form {
  width: 100%;
  max-width: 300px;
  margin: 0 auto;
  display: block;
  padding: .75rem;
  border: 2px solid #FD8204;
  color: #FD8204;
  font-size: 20px;
  font-weight: 500;
  background-color: #FFF;
  border-radius: 10px;
  transition: all ease .2s;

  &:disabled {
    background-color: lighten(#6D6E71, 50%);
  }
}
</style>



// WEBPACK FOOTER //
// resources/js/views/TeachersForm/Forms/success.vue